import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d9c59d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "found-list-wrapper" }
const _hoisted_2 = {
  key: 0,
  role: "list",
  "aria-label": "습득물 목록"
}
const _hoisted_3 = {
  key: 1,
  class: "no-result"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!!$props.foundList.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.foundList, (found) => {
            return (_openBlock(), _createElementBlock("li", {
              key: found.uid,
              role: "listitem"
            }, [
              _createVNode($setup["LostFoundRow"], {
                lostFound: found,
                onOnClickRow: $setup.emitOnClickRow
              }, null, 8 /* PROPS */, ["lostFound"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString($props.emptyText), 1 /* TEXT */)
        ]))
  ]))
}